/* eslint-disable vue/padding-lines-in-component-definition */
import { Workbox } from 'workbox-window'
import Swal from '@/includes/swal'

const ToastConfirm = Swal.mixin({
  position: 'bottom-end',
  toast: false,
  backdrop: false,
  showConfirmButton: true,
  focusConfirm: false,
  focusDeny: false,
  allowEscapeKey: false,
  confirmButtonColor: '#ccc',
  buttonsStyling: false,
  customClass: {
    confirmButton: 'btn btn--primary',
    container: 'workbox-toast',
    popup: 'swal2-toast',
  },
})

if ('serviceWorker' in navigator) {
  const wb = new Workbox('/service-worker.js')

  const showSkipWaitingPrompt = async () => {
    // Assuming the user accepted the update, set up a listener
    // that will reload the page as soon as the previously waiting
    // service worker has taken control.
    wb.addEventListener('controlling', () => {
      // At this point, reloading will ensure that the current
      // tab is loaded under the control of the new service worker.
      // Depending on your web app, you may want to auto-save or
      // persist transient state before triggering the reload.
      // @ts-ignore
      window.location.reload(true)
    })

    ToastConfirm.fire({
      icon: 'info',
      title: ' ',
      text: 'Er is een update beschikbaar. Klik om te vernieuwen.',
      confirmButtonText: 'Vernieuw'
    }).then(result => {
      if (result.value) wb.messageSkipWaiting()
    })
  }

  // Add an event listener to detect when the registered
  // service worker has installed but is waiting to activate.
  wb.addEventListener('waiting', () => {
    showSkipWaitingPrompt()
  })

  window.addEventListener('load', function () {
    wb.register()
  })

  addEventListener('activate', event => {
    // @ts-ignore
    event.waitUntil(async function () {
      // Feature-detect
      // @ts-ignore
      if (self.registration.navigationPreload) {
        // Enable navigation preloads!
        // @ts-ignore
        await self.registration.navigationPreload.enable()
      }
    }())
  })

  addEventListener('fetch', event => {
    // @ts-ignore
    event.respondWith(async function () {
      // Respond from the cache if we can
      // @ts-ignore
      const cachedResponse = await caches.match(event.request)
      if (cachedResponse) return cachedResponse

      // Else, use the preloaded response, if it's there
      // @ts-ignore
      const response = await event.preloadResponse
      if (response) return response

      // Else try the network.
      // @ts-ignore
      return fetch(event.request)
    }())
  })
}
